import { render, staticRenderFns } from "./Project-preview-button.vue?vue&type=template&id=2b741ac6&"
import script from "./Project-preview-button.vue?vue&type=script&lang=ts&"
export * from "./Project-preview-button.vue?vue&type=script&lang=ts&"
import style0 from "./Project-preview-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports